import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tag_bg",
  "use": "icon-tag_bg-usage",
  "viewBox": "0 0 200 39.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 39.8\" id=\"icon-tag_bg\">\r\n<g>\r\n\t<path fill=\"#3988F7\" d=\"M38,0h124.1l15.8,20l-15.8,19.9H38L22.1,19.9L38,0z\" />\r\n\t<path fill=\"#3988F7\" d=\"M26.9,0h5.5L16.6,20l15.8,19.9h-5.5L11.1,19.9L26.9,0z\" />\r\n\t<path fill=\"#3988F7\" d=\"M15.8,0h5.5L5.5,20l15.8,19.9h-5.5L0,19.9L15.8,0z\" />\r\n\t<path fill=\"#3988F7\" d=\"M173.1,0h-5.5l15.8,20l-15.8,19.9h5.5l15.8-19.9L173.1,0z\" />\r\n\t<path fill=\"#3988F7\" d=\"M184.2,0h-5.5l15.8,20l-15.8,19.9h5.5L200,19.9L184.2,0z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tag_bg.svg
// module id = CSPR
// module chunks = 13